module.exports = __webpack_public_path__ + "img/logo_mgd.297444b5.png";